module.exports = __webpack_public_path__ + "img/redo.934b6b23.svg";